define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/StorageUtil',
	
	'model/Context',
	'state/UIState',
	'service/UIStateManager',
	'service/EventListenerRegistry',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ActivationView',
	'view/ControlBarView',
	
	'model/ErrorType',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/ActivationState_strings'
], function (
	Logger,
	Util,
	UiUtil,
	StorageUtil,
	
	Context,
	UIState,
	UIStateManager,
	EventListenerRegistry,
	ProviderInfoView,
	NavigationView,
	ActivationView,
	ControlBarView,
	
	ErrorType,
	
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ActivationState class
	 */
	function ActivationState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_activationView = new ActivationView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-activation');

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.authentication);

		_controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.core().abortActivate();
			_uiStateManager.back();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.core().abortActivate();
			_uiStateManager.abort();
		});

		UIState.call(this, 'activation');


		// private methods

		function errorOccurred(error) {
			if (error.type() === ErrorType.RECOVERABLE) {
				StorageUtil.store("activate_error",error.toObject(),true);
				_uiStateManager.back();
			} else {
				_uiStateManager.change('error', error);
			}
		}


		// public methods

		this.title = function () {
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				return _uiStateManager.core().optionsManager().providerInfo().description();
			}

			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _activationView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, activationData) {
			EventListenerRegistry.addOneTimeListener(
					[ 'CLOUD_IDENTITY_REQUEST_FAILED', 'SELECT_OPTION_FAILED', 'ACTIVATION_FAILED' ], errorOccurred);

			_providerInfoView.update(
					(_uiStateManager.core().context() === Context.SERVICE_PROVIDER) ?
							_uiStateManager.core().optionsManager().providerInfo() :
								_uiStateManager.core().cloudIdentitiesManager().providerInfo());

			var fido = false;
			
			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER 
					&& activationData.hasOwnProperty('identity')
					&& activationData.identity !== null) {
				var binding = activationData['identity'].bindingProtocol()[0];
				fido = (binding.type() === "http://ws.skidentity.de/ci/binding/key/v1.0" && binding.origin() === "FIDO/WebAuthn");
			}

			_activationView.update(activationData['authenticationOption'], fido);

			_activationView.enableAnimation();

			if (_uiStateManager.core().context() === Context.SERVICE_PROVIDER) {
				_uiStateManager.core().activate(activationData['authenticationOption'],
						activationData['requestedAttributes'], activationData['identity'],
						activationData['binding'], activationData['secret']);
			} else if (activationData.hasOwnProperty('revokation')) {
				_uiStateManager.core().revokeCloudIdentities(
						activationData['authenticationOption'], activationData['requestedAttributes']);
			} else {
				_uiStateManager.core().createCloudIdentity('issue',
						activationData['authenticationOption'], activationData['requestedAttributes']);
			}

			Util.callCallbacks(doneCallback);

			UiUtil.scrollTo(_navigationView.get());
		};

		this.leave = function (doneCallback) {
			EventListenerRegistry.removeListener(
					[ 'CLOUD_IDENTITY_REQUEST_FAILED', 'SELECT_OPTION_FAILED','ACTIVATION_FAILED' ], errorOccurred);

			_activationView.disableAnimation();

			Util.callCallbacks(doneCallback);
		};
	}

	ActivationState.prototype = Object.create(UIState.prototype);

	return ActivationState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/ActivationState.js
// module id = 317
// module chunks = 2